/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `offer` - Offer guarantee
 * * `performance` - Performance guarantee
 * * `customs` - Customs guarantee
 * * `ata_carnet` - ATA Carnet guarantee
 * * `advance` - Advance repayment guarantee
 */
export enum GuaranteeTypeEnum {
  OFFER = 'offer',
  PERFORMANCE = 'performance',
  CUSTOMS = 'customs',
  ATA_CARNET = 'ata_carnet',
  ADVANCE = 'advance',
}
